import {
  TBctxItem,
  TBCTXKeys,
  TPerPieceLineInTransactionItem,
  TPerPieceLineInTransactionItemWithModifiedLinkedVId,
} from '@monorepo/types';
import { ModifiersZTableModel } from '@monorepo/ui';
import { TTableCellTree } from '../../../../../table/models/table.type';
import * as _ from 'lodash';
import * as moment from 'moment';
const DEFAULT_VALUE = '--';
export const PER_PIECE_LINE_IN_TRANSACTIONS_LISTING_MODEL = {
  createModel: (
    items: TPerPieceLineInTransactionItemWithModifiedLinkedVId[],
    orderKeys: TBCTXKeys[],
    bctxKeysToDisplayMap: Record<TBCTXKeys, string>,
    dayStartTime: number,
  ) => {
    const headerConfig: TTableCellTree[] = orderKeys.map((keyWithoutSize) => {
      return {
        type: 'TEXT_CELL',
        text: bctxKeysToDisplayMap[keyWithoutSize],
      };
    });
    return ModifiersZTableModel.createTableModel(
      items,
      {
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'DATE TIME',
          },
          ...headerConfig,
          {
            type: 'TEXT_CELL',
            text: 'QTY',
          },
          {
            type: 'TEXT_CELL',
            text: 'ACTION',
            stickyType: 'RIGHT',
          },
        ],
      },
      (item) => {
        const defaultCells: TTableCellTree[] = orderKeys.map((keyWithoutSize) => {
          return {
            type: 'TEXT_CELL',
            text: PER_PIECE_LINE_IN_TRANSACTIONS_LISTING_MODEL.getBctxValue(item.item.bctx_items, keyWithoutSize),
          };
        });
        return {
          type: 'ROW',
          rowItem: item,
          isSelected: false,
          cells: [
            {
              type: 'TEXT_CELL',
              text: moment(item.item.datetime).format('DD-MM-YYYY h:mm A'),
            },
            ...defaultCells,
            {
              type: 'TEXT_CELL',
              text: item.item.qty,
            },
            {
              type: 'ACTION_CELL',
              actionType: 'CUSTOM_ACTION',
              customTxt: 'UNDO',
              isDisabled: item.item.datetime <= dayStartTime,
            },
          ],
        };
      },
    );
  },

  getBctxValue(bctxItems: TBctxItem[], key: TBCTXKeys) {
    const index = bctxItems.findIndex((item) => item.k === key);
    return index > -1 ? bctxItems[index].v : DEFAULT_VALUE;
  },
};
